const products = [
    
    {
      id: 1,
      title: "GSAP Page Transitions",
      description: "Smooth page transition using BarbaJS and GSAP.",
      price: "FREE",
      tag: "🤍 Animation",
      image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/xp34p3vii42rhx3m7zsh.gif",
      productLink: "https://github.com/DevrajDC/page-transition-v2",
    },
    {
      id: 2,
      title: "React Cursors",
      description: "Smooth cursor with transition effects for your ReactJS Projects.",
      price: "FREE",
      tag: "😍 Cursors",
      image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/wta93riog0r7zgqp7rrn.gif",
      productLink: "https://www.npmjs.com/package/react-cursors",
    },
    {
      id: 3,
      title: "GSAP Page Transitions",
      description: "Smooth page transition using BarbaJS and GSAP.",
      price: "FREE",
      tag: "🤍 Animation",
      image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/8iyqaljua3735v7mvokq.gif",
      productLink: "https://github.com/DevrajDC/page-transition-v1",
    },
    {
      id: 4,
      title: "Page Reveal Animation",
      description: "Stroke logo preloader/ page reveal animation using GSAP.",
      price: "FREE",
      tag: "🤍 Animation",
      image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/mi3qh1po9eby0ud3krkf.gif",
      productLink: "https://github.com/DevrajDC/page-reveal-transitions",
    },
    {
      id: 5,
      title: "Resources Hub",
      description: "High-quality resources and tools which can be used in daily work.",
      price: "FREE",
      tag: "🤩 Resources",
      image: "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/yrakbgnyxitkaqzh0qs9.png",
      productLink: "https://github.com/DevrajDC/resourceshub",
    },
  ];
  
  
export default products;